export default __webpack_public_path__ + "static/media/screen5.14cb4d07.webp";